import React from 'react';
import { KineticLib } from '../index';

export default ({ children }) => (
  <KineticLib locale="en">{children}</KineticLib>
);
